import React from "react";

function ServerError() {
  return (
    <div className="h-lvh w-full text-lg">
      <div className="text-gray-700 text-center my-16 mx-auto space-y-4">
        <h1 className="text-6xl font-bold">
          5<span className="text-gray-500">0</span>0
        </h1>
        <h2 className="text-3xl">Erreur interne du serveur</h2>
        <p>
          Une erreur inattendue s'est produite. Veuillez réessayer plus tard.
        </p>
      </div>
    </div>
  );
}

export default ServerError;
